import { connect } from 'react-redux';

import { GlobalContextValue } from '../../shared/containerComponents/globalContext/globalContextValues';
import {
  jurisdictionDescriptionSelector,
  isFetchingJurisdictionsSelector,
} from '../../shared/store/selectors';

export default connect(
  state => ({
    label: 'Jurisdiction',
    value: jurisdictionDescriptionSelector(state),
    isBusy: isFetchingJurisdictionsSelector(state),
  }),
  null,
)(GlobalContextValue);
